module.exports = __webpack_public_path__ + "static/img/banner.ba47f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 34